import request from '@/request/request'

/**
 * 保存权证信息
 * @param {} parameter 
 * @returns 
 */
export function saveWarrant (parameter) {
  return request({
    url: '/e-find-property/assetCertificate/saveWarrant',
    method: 'post',
    data: parameter
  })
}

/**
 * 提交权证信息审核
 * @param {} parameter 
 * @returns 
 */
export function submitWarrant (parameter) {
  return request({
    url: '/e-find-property/assetCertificate/submitWarrant',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取权证列表
 * @param {} parameter 
 * @returns 
 */
export function listWarrant (parameter) {
  return request({
    url: '/e-find-property/assetCertificate/listWarrant',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取权证详情
 * @param {} parameter 
 * @returns 
 */
export function getWarrantDetail (parameter) {
  return request({
    url: '/e-find-property/assetCertificate/getWarrantDetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除权证信息
 * @param {} parameter 
 * @returns 
 */
export function deleteWarrant (parameter) {
  return request({
    url: '/e-find-property/assetCertificate/deleteWarrant',
    method: 'delete',
    params: parameter
  })
}

/**
 * 房源信息选择权证详情
 * @param {} parameter 
 * @returns 
 */
export function listWarrantByWebId (parameter) {
  return request({
    url: '/e-find-property/housingResources/listWarrant',
    method: 'post',
    data: parameter
  })
}

/**
 * 提交房源信息
 * @param {} parameter 
 * @returns 
 */
export function submitResource (parameter) {
  return request({
    url: '/e-find-property/housingResources/submitResource',
    method: 'post',
    data: parameter
  })
}

/**
 * 提交房源信息
 * @param {} parameter 
 * @returns 
 */
export function listResource (parameter) {
  return request({
    url: '/e-find-property/housingResources/listResource',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取权证详情
 * @param {} parameter 
 * @returns 
 */
export function getResourceDetail (parameter) {
  return request({
    url: '/e-find-property/housingResources/getResourceDetail',
    method: 'get',
    params: parameter
  })
}

/**
 * 删除权证信息
 * @param {} parameter 
 * @returns 
 */
export function deleteResource (parameter) {
  return request({
    url: '/e-find-property/housingResources/deleteResource',
    method: 'delete',
    params: parameter
  })
}

